import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Usuario from "model/administracao/cadastro/Usuario";
import Patrimonio from "model/patrimonio/Patrimonio";

export function produtoCompleteMethod(produtos: Produto[], query: string): Produto[] {
    
    let filtered: Produto[] = [];
    for (let i = 0; i < produtos.length; i++) {
        let produto = produtos[i];
        if (normalizeString(produto.nome.toLowerCase()).indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(produto);
        } else if (normalizeString(produto.codigo?.toLowerCase()||"").indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(produto);
        } else if (normalizeString(produto.codigo + " - " + produto.nome).toLowerCase().indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(produto);
        } else if (normalizeString(produto.codigoInterno?.toLowerCase()||"").indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(produto);
        } else if (normalizeString(produto.codigo + " - " + produto.codigoInterno + " - " + produto.nome).toLowerCase().indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(produto);
        }
    }
    return filtered;
}

export function produtoItemTemplate(item: Produto) {
    return item.codigoInterno ? item.codigo + " - " + item.codigoInterno + " - " + item.nome : item.codigo + " - " + item.nome;
}


function normalizeString(str: string){
    str = str.replace(/[ÀÁÂÃÄÅ]/,"A");
    str = str.replace(/[àáâãäå]/,"a");
    str = str.replace(/[ÈÉÊË]/,"E");
    str = str.replace(/[èéêë]/,"e");
    str = str.replace(/[ÌÍÎÏ]/,"I");
    str = str.replace(/[ìíîï]/,"i");
    str = str.replace(/[ÒÓÔÕÖ]/,"O");
    str = str.replace(/[òóôõö]/,"o");
    str = str.replace(/[ÙÚÛÜ]/,"U");
    str = str.replace(/[ùúûü]/,"u");

    return str;
}

export function pessoaCompleteMethod(pessoas: Pessoa[], query: string): Pessoa[] {
    
    let filtered: Pessoa[] = [];
    for (let i = 0; i < pessoas.length; i++) {
        let pessoa = pessoas[i];
        let codigo = pessoa.codigoInterno.toString();
    
        if (normalizeString(pessoa.nome.toLowerCase()).indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(pessoa);
        } else if (normalizeString(codigo?.toLowerCase()||"").indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(pessoa);
        } else if (normalizeString(codigo + " - " + pessoa.nome).toLowerCase().indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(pessoa);
        } 
    }
    return filtered;
}

export function defaultCompleteMethod(list: any[], query: string, label: string): any[] {
    
    let filtered: any[] = [];
    for (let i = 0; i < list.length; i++) {
        let item : any = list[i];
        if(typeof item[label] == "string"){
            if (normalizeString((item[label] as string).toLowerCase()).indexOf(normalizeString(query.toLowerCase())) == 0) {
                filtered.push(item);
            }
        }
    }
    return filtered;
}

export function pessoaItemTemplate(item: Pessoa) {
    return item.codigoInterno + " - " + item.nome;
}

export function usuarioItemTemplate(item: Usuario) {
    return item.nome + " - " + item.email;
}

export function usuarioCompleteMethod(usuarios: Usuario[], query: string): Usuario[] {
    
    let filtered: Usuario[] = [];
    for (let i = 0; i < usuarios.length; i++) {
        let usuario = usuarios[i];
    
        if (normalizeString(usuario.nome?.toLowerCase() ?? '').indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(usuario);
        } else if (normalizeString(usuario.email?.toLowerCase()||"").indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(usuario);
        } else if (normalizeString(usuario.nome + " - " + usuario.email).toLowerCase().indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(usuario);
        } 
    }
    return filtered;
}

export function patrimonioCompleteMethod(patrimonios: Patrimonio[], query: string): Patrimonio[] {
    
    let filtered: Patrimonio[] = [];
    for (let i = 0; i < patrimonios.length; i++) {
        let patrimonio = patrimonios[i];
        let codigo = patrimonio.codigo.toString();
    
        if (normalizeString(patrimonio.produto?.nome?.toLowerCase() ?? '').indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(patrimonio);
        } else if (normalizeString(codigo?.toLowerCase()||"").indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(patrimonio);
        } else if (normalizeString(codigo + " - " + patrimonio.produto?.nome).toLowerCase().indexOf(normalizeString(query.toLowerCase())) == 0) {
            filtered.push(patrimonio);
        } 
    }
    return filtered;
}

export function patrimonioItemTemplate(item: Patrimonio) {
    return item.codigo + " - " + item.produto?.nome;
}